module.exports = __webpack_public_path__ + "img/db_pb0f5f.939cb7bc.png";